/**
 * Agregador central das categorias de ajuda.
 * Cada categoria é definida no seu próprio arquivo em ./categories/
 * Para adicionar novas seções, crie um arquivo na pasta categories/
 * e importe-o aqui.
 */
import { CONFIGURACOES_GLOBAIS } from "./categories/settings";
import { CADASTRO_MATRICULA } from "./categories/enrollment";
import { CONTROLE_PRESENCA } from "./categories/attendance";
import { AVALIACOES_TECNICAS } from "./categories/assessments";

export const HELP_CATEGORIES = [
    CONFIGURACOES_GLOBAIS,
    CADASTRO_MATRICULA,
    CONTROLE_PRESENCA,
    AVALIACOES_TECNICAS,
];
